module.exports = __webpack_public_path__ + "sansg/img/cloud.3c3d4e0a.png";